module.exports = __webpack_public_path__ + "img/Steor-Icon-07.51f6cb0a.svg";